import React, {useState} from "react";
import connection from "../../connection";
import general from "../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Accordion from "components/Accordion/Accordion.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import MoreVert from "@material-ui/icons/MoreVert";

import modelosStyle from "assets/jss/material-dashboard-pro-react/views/modelosStyle";
//Material UI Icons
import Create from "@material-ui/icons/Create";
import Add from "@material-ui/icons/Add";

import SweetAlert from "../../components/SweetAlertWrapper";
//FontAwesome Icons
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashAlt} from '@fortawesome/free-solid-svg-icons'
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {Check} from "@material-ui/icons";

class PaginaModelo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modelo: null,
      modal: null
    };

    this.confirmDeleteArea = this.confirmDeleteArea.bind(this);
    this.confirmDeleteModulo = this.confirmDeleteModulo.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.deleteArea = this.deleteArea.bind(this);
    this.deleteModulo = this.deleteModulo.bind(this);
    this.editArea = this.editArea.bind(this);
    this.newModuloModal = this.newModuloModal.bind(this);
    this.newAreaModal = this.newAreaModal.bind(this);
    this.addNewModulo = this.addNewModulo.bind(this);
    this.addNewArea = this.addNewArea.bind(this);

    this.reloadModelo = async () => {
      const {location} = this.props;
      let id = location.pathname.split("/modelo/")[1];
      let detalhes = await connection.get("modelo/detalhes", {id: id});
      this.setState({
        modelo: detalhes
      });
    };
  }

  hideModal() {
    this.setState({
      modal: null
    });
  }

  deleteArea(area) {
    connection.post("modelo/area/apagar", {area: area.id, modelo: this.state.modelo.id}, (data) => {
      if (data.success) {
        this.hideModal();
        this.reloadModelo();
        general.success("Área '" + area.designacao + "' apagada com sucesso.", "Sucesso!");
      } else {
        general.error("Por favor tente novamente mais tarde.", "Erro!")
      }
    })
  }

  deleteModulo(modulo) {
    connection.post("modelo/modulo/apagar", {modulo: modulo.id, modelo: this.state.modelo.id}, (data) => {
      if (data.success) {
        this.hideModal();
        this.reloadModelo();
        general.success("Módulo '" + modulo.designacao + "' apagado com sucesso.", "Sucesso!");
      } else {
        general.error("Por favor tente novamente mais tarde.", "Erro!");
      }
    })
  }

  editArea(area) {
    connection.post("modelo/area/editar", area, (data) => {
      if (data.success) {
        this.hideModal();
        this.reloadModelo();
        general.success("Alterações salvas com sucesso.", "Sucesso");
      } else {
        general.error("Por favor tente novamente mais tarde.", "Erro!");
      }
    })
  }

  addNewArea(area) {
    connection.post("modelo/area/nova", area, (data) => {
      this.hideModal();
      this.reloadModelo();
      general.success("Adicionada nova área.", "Sucesso");
    }, () => {
      general.error("Por favor tente novamente.", "Erro!");
    })
  }

  async newAreaModal() {
    const {classes} = this.props;

    let modelo_area = null;

    let areas = await connection.get("modulo/area/listagem");

    //Filtrar areas para ocultar usadass
    let areas_usadas = this.state.modelo.areas.map((a) => a.id);
    areas = areas.filter((area) => !areas_usadas.includes(area.id));

    let Content = () => {
      const [modelo_area_state, setModeloArea] = useState(null);

      return <form autoComplete="off" className={classes.addForm}>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelo_area" className={classes.selectLabel}>
            Área
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={modelo_area_state}
            onChange={(event) => {
              modelo_area = event.target.value;
              setModeloArea(event.target.value);
            }}
            inputProps={{
              name: "modelo_area",
              id: "modelo_area"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha a área</MenuItem>
            {areas.map((area) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={area.id}>{area.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Adicionar Área</span>
        </div>)}
        onConfirm={() => {
          this.addNewArea({
            area: modelo_area ? modelo_area : undefined,
            modelo: this.state.modelo.id
          });
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Criar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  }

  addNewModulo(modulo) {
    connection.post("modelo/modulo/novo", modulo,
      (data) => {
        if (data.success) {
          this.hideModal();
          this.reloadModelo();
          general.success("Adicionado novo módulo.", "Sucesso");
        } else {
          general.error("Por favor tente novamente.", "Erro!");
        }
      })
  }

  async newModuloModal(area) {
    const {classes} = this.props;
    let modelo_modulo = null;
    let modelo_modulo_obrigatorio = 0;

    let modulos = await connection.get("modulo/listagem?area=" + parseInt(area.id));

    //Filtrar módulos para ocultar usados
    let modulos_usados = this.state.modelo.modulos.map((mod) => mod.id);
    modulos = modulos.filter((modulo) => !modulos_usados.includes(modulo.id));

    let Content = () => {
      const [modelo_modulo_state, setModeloModulo] = useState(null);
      const [modelo_modulo_obrigatorio_state, setObrigatorio] = useState(modelo_modulo_obrigatorio);

      return <form autoComplete="off" className={classes.addForm}>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelo_area" className={classes.selectLabel}>
            Módulo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={modelo_modulo_state}
            onChange={(event) => {
              modelo_modulo = event.target.value;
              setModeloModulo(event.target.value);
            }}
            inputProps={{
              name: "modelo_modulo",
              id: "modelo_modulo"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>{modulos.length > 0 ? "Escolha o módulo" : "Não existem mais módulos para esta área"}</MenuItem>
            {modulos.map((modulo) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={modulo.id}>{modulo.codigo} | {modulo.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControlLabel
          control={
            <Checkbox
              checked={modelo_modulo_obrigatorio_state}
              tabIndex={-1}
              onClick={() => {
                modelo_modulo_obrigatorio = !modelo_modulo_obrigatorio;
                setObrigatorio(modelo_modulo_obrigatorio);
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Obrigatório"}
        />
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Novo Módulo</span>
        </div>)}
        onConfirm={() => {
          this.addNewModulo({
            modulo: modelo_modulo ? modelo_modulo : undefined,
            obrigatorio: modelo_modulo_obrigatorio,
            modelo: this.state.modelo.id
          });
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Criar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  }

  editModuloModal = async (modulo) => {
    const {classes} = this.props;

    let modelo_modulo_obrigatorio = modulo.obrigatorio;

    let Content = () => {
      const [modelo_modulo_obrigatorio_state, setObrigatorio] = useState(modelo_modulo_obrigatorio);

      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Módulo"
          id="modelo_modulo_editar"
          disabled
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: modulo.designacao,
            name: "modelo_modulo_editar",
            disabled: true
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={modelo_modulo_obrigatorio_state}
              tabIndex={-1}
              onClick={() => {
                modelo_modulo_obrigatorio = !modelo_modulo_obrigatorio;
                setObrigatorio(modelo_modulo_obrigatorio);
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Obrigatório"}
        />
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Módulo</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("modelo/modulo/editar", {
            modelo: this.state.modelo.id,
            modulo: modulo.id,
            obrigatorio: modelo_modulo_obrigatorio,
          });
          this.hideModal();
          this.reloadModelo();
          general.success("Módulo editado", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  }

  confirmDeleteArea(area) {
    this.setState({
      modal: (
        <SweetAlert
          warning
          title="Apagar Área"
          onConfirm={() => this.deleteArea(area)}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText="Apagar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Atenção! Ao apagar esta área ({area.designacao}), todos os módulos associados também serão apagados. Esta ação
          é irreversível.
        </SweetAlert>
      )
    });
  }

  confirmDeleteModulo(modulo) {
    this.setState({
      modal: (
        <SweetAlert
          warning
          title="Apagar Módulo"
          onConfirm={() => this.deleteModulo(modulo)}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText="Apagar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Atenção! Está prestes a apagar o módulo '{modulo.designacao}'. Esta ação é irreversível.
        </SweetAlert>
      )
    });
  }

  buildAccordionContent = () => {
    let {areas, modulos} = this.state.modelo;
    const {classes} = this.props;

    let accordionContent = [];
    areas.forEach((area) => {
      let areaContent = [];
      let modulos_area = modulos.filter((modulo) => modulo.area === area.id);
      modulos_area.forEach((modulo) => {
        areaContent.push(<GridItem xs={12} sm={6} md={3} key={modulo.id}>
          <Card color="primary" className={classes.moduloCard}>
            <CardHeader color="primary" icon className={classes.moduleCardHeader}>
              <h4 className={classes.innerCardTitle}>{modulo.codigo} - {modulo.designacao}</h4>
              <div style={{position: "absolute", top: -3, right: -16}}>
                <CustomDropdown
                  hoverColor="info"
                  buttonText={<MoreVert/>}
                  caret={false}
                  buttonProps={{
                    justIcon: true,
                    style: {marginBottom: "0"},
                    simple: true,
                    round: true
                  }}
                  dropdownList={[
                    {
                      label: "Editar",
                      onClick: () => this.editModuloModal(modulo)
                    },
                    {
                      label: "Apagar",
                      onClick: () => this.confirmDeleteModulo(modulo)
                    }
                  ]}
                />
              </div>
            </CardHeader>
            <CardBody className={classes.moduloCardBody}>
              <table>
                <tr>
                  <td>Frequência:</td>
                  <td><span>{modulo.obrigatorio ? "Obrigatório" : "Opcional"}</span></td>
                </tr>
              </table>
            </CardBody>
          </Card>
        </GridItem>);
      });

      areaContent.push(<GridItem xs={12} sm={6} md={3} xl={2} key={area.id}>
        <Button
          justIcon
          round
          simple
          onClick={() => {
            this.newModuloModal(area);
          }}
          color="primary"
          className={classes.addModuloButton}
        >
          <Add/>
        </Button>
      </GridItem>);

      accordionContent.push({
        area_id: area.id,
        title: area.designacao,
        content: <React.Fragment>
          <GridContainer className={classes.areaContentGrid}>
            {areaContent}
          </GridContainer>
        </React.Fragment>,
        actions: <React.Fragment>
          <Button
            justIcon
            round
            simple
            onClick={(e) => {
              e.stopPropagation();
              this.confirmDeleteArea(area);
            }}
            color="danger"
            className={classes.deleteAreaButton}
          >
            <FontAwesomeIcon icon={faTrashAlt}/>
          </Button>
        </React.Fragment>
      })
    });
    return accordionContent;
  };

  async componentDidMount() {
    this.reloadModelo();
  }

  editarModelo = async () => {
    const {classes} = this.props;

    let modelo = {
      id: this.state.modelo.id,
      codigo_modelo: this.state.modelo.codigo_modelo,
      designacao: this.state.modelo.designacao,
      ativado: this.state.modelo.ativado
    };

    let Content = () => {
      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Código"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: modelo.codigo_modelo,
            onChange: (e) => {
              modelo.codigo_modelo = e.target.value;
            }
          }}
        />
        <CustomInput
          labelText="Designação"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: modelo.designacao,
            onChange: (e) => {
              modelo.designacao = e.target.value;
            }
          }}
        />
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Modelo ativado e disponível para utilização
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            onChange={(event) => {
              modelo.ativado = event.target.value;
            }}
            defaultValue={modelo.ativado}
          >
            <MenuItem classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Não</MenuItem>
            <MenuItem classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={1}>Sim</MenuItem>
          </Select>
        </FormControl>
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Modelo</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("modelo/editar", modelo);
          this.hideModal();
          this.reloadModelo()
          general.success("Modelo editado", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  }

  render() {
    const {classes} = this.props;
    return this.state.modelo ? (<div className={classes.cursosContainer}>
      {this.state.modal}
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}>{this.state.modelo.designacao + (this.state.modelo.tags ? ' (' + this.state.modelo.tags + ')' : '')} ({this.state.modelo.ativado ? "ativado" : "desativado"})</h4>
                <div>
                  <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={this.editarModelo}>
                    <Create/> Editar
                  </Button>
                  <Button className={classes.addStuffButton + " " + classes.button + " " + classes.primary} onClick={this.newAreaModal}>
                    <Add/> Nova Área
                  </Button>
                </div>
              </div>
            </CardHeader>
            <CardBody>
              {this.state.modelo.areas && this.state.modelo.areas.length > 0 ? (<Accordion
                collapses={this.buildAccordionContent()}
              />) : (<h4>Ainda não foram adicionadas áreas a este modelo.</h4>)}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>) : (<span>Loading..</span>);
  }
}

export default withStyles(modelosStyle)(PaginaModelo);
